<script lang="ts">
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { FlexLayoutSectionProps } from './types';

  export let entryId: FlexLayoutSectionProps['entryId'];
  export let entries: FlexLayoutSectionProps['entries'];
  export let customCssClass: FlexLayoutSectionProps['customCssClass'];
</script>

<div
  class="FlexLayoutSection FlexLayoutSection-{entryId} FlexLayoutSection-{entryId}-box-properties {customCssClass}"
  data-entry-id={entryId}
>
  <DynamicChildrenComponent children={entries} />
</div>

<style lang="scss">
  @layer standard-components {
    .FlexLayoutSection {
      display: flex;
      flex-wrap: wrap;
    }
  }
</style>
